/*
 * Created by Trevor Sears <trevor@trevorsears.com> (https://trevorsears.com/).
 * 3:43 PM -- August 31st, 2021.
 * Project: @jsdsl/iterator
 * 
 * @jsdsl/iterator - A collection of classes that allow iteration over a predefined collection of elements.
 * Copyright (C) 2021 Trevor Sears
 * 
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 * 
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 * 
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

/**
 * NPM main class used for exporting this package's contents.
 *
 * @author Trevor Sears <trevor@trevorsears.com>
 * @version v1.0.0
 * @since v0.1.0
 */

export { Iterator } from "./iterator";
export { AbstractIterator } from "./abstract-iterator";

export { Iterable } from "./iterable";
export { AbstractIterable } from "./abstract-iterable";
